import { message } from "antd";
import htmlToPdfMake from "html-to-pdfmake"; // Ensure the correct import path
import pdfMake from "pdfmake/build/pdfmake"; // Ensure the correct import path
import websiteLogo from "../../../images/logo.png"; // Adjust based on your project structure

export const getBase64Logo = (): Promise<string> => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = websiteLogo;
        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx?.drawImage(img, 0, 0);
            resolve(canvas.toDataURL("image/png"));
        };
        img.onerror = (err) => reject(err);
    });
};

export const exportToPDF = async ({
    editorRef,
    onBoardingDescriptionResponse,
    templateName,
    isTemplateChecked,
}: {
    editorRef: React.RefObject<HTMLDivElement>;
    onBoardingDescriptionResponse: any; // Replace `any` with the appropriate type
    templateName: string;
    isTemplateChecked: boolean;
}) => {
    if (editorRef.current) {
        const originalDisplay = editorRef.current.style.display;
        editorRef.current.style.display = "block";

        try {
            const logoBase64 = await getBase64Logo();
            const htmlContent = editorRef.current.innerHTML;

            const pdfContent = htmlToPdfMake(htmlContent, {
                window,
                customTagStyles: {
                    p: (node: any) => {
                        if (node.classList.contains("ql-align-right")) {
                            return { alignment: "right" };
                        } else if (node.classList.contains("ql-align-center")) {
                            return { alignment: "center" };
                        } else if (node.classList.contains("ql-align-justify")) {
                            return { alignment: "justify" };
                        } else {
                            return { alignment: "left" };
                        }
                    },
                },
            });

            const documentDefinition = {
                header: {
                    columns: [
                        {
                            image: logoBase64,
                            fit: [100, 50],
                            alignment: "left",
                        },
                        { text: "", width: "*" },
                    ],
                    margin: [10, 10, 10, 20],
                },
                content: pdfContent,
                styles: {
                    header: { fontSize: 18, bold: true },
                    subheader: { fontSize: 14, bold: true },
                    text: { fontSize: 12 },
                    listItem: {
                        margin: [10, 0, 0, 5],
                    },
                },
            };

            editorRef.current.style.display = originalDisplay;

            let pdfFileName = onBoardingDescriptionResponse.searchConfig.jobTitles[0];

            if (!templateName && isTemplateChecked) {
                message.error("Please enter template name");
                return;
            } else if (templateName) {
                pdfFileName = templateName;
            }

            pdfMake.createPdf(documentDefinition).download(
                `${pdfFileName.toLowerCase().replace(/ /g, "_")}.pdf`
            );
            message.success("Exported as PDF!");
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    } else {
        console.error("Editor content is not available.");
    }
};
